module.exports={
	"Form": "ObservationApprovalStateEditManifest",
	"Scope": "ObservationApprovalState-Edit",
	"Descriptors":
	{
		"ObservationApprovalStateDetails.IDObservationApprovalState":
		{
			"Name": "ID",
			"Hash": "ObsStateEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsStateEditIdentity",
				"Group": "ObsStateEditIdentity"
			}
		},
		"ObservationApprovalStateDetails.GUIDObservationApprovalState":
		{
			"Name": "GUID",
			"Hash": "ObsStateEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsStateEditIdentity",
				"Group": "ObsStateEditIdentity"
			}
		},
		"ObservationApprovalStateDetails.Name":
		{
			"Name": "State Name",
			"Hash": "ObsStateEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ObsStateEditIdentity",
				"Group": "ObsStateEditIdentity"
			}
		},
		"ObservationApprovalStateDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "ObsStateEdit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 6,
				"Section": "ObsStateEditIdentity",
				"Group": "ObsStateEditIdentity"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsStateEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsStateEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
